__turbopack_context__.v({
  "actions": "Community-module__oU5wjW__actions",
  "back": "Community-module__oU5wjW__back",
  "body": "Community-module__oU5wjW__body",
  "cancelComment": "Community-module__oU5wjW__cancelComment",
  "comment": "Community-module__oU5wjW__comment",
  "commentBody": "Community-module__oU5wjW__commentBody",
  "commentComposer": "Community-module__oU5wjW__commentComposer",
  "commentContent": "Community-module__oU5wjW__commentContent",
  "commentForm": "Community-module__oU5wjW__commentForm",
  "commentInput": "Community-module__oU5wjW__commentInput",
  "commentList": "Community-module__oU5wjW__commentList",
  "commentMeta": "Community-module__oU5wjW__commentMeta",
  "commentRow": "Community-module__oU5wjW__commentRow",
  "comments": "Community-module__oU5wjW__comments",
  "compactReactions": "Community-module__oU5wjW__compactReactions",
  "composerFooter": "Community-module__oU5wjW__composerFooter",
  "deleted": "Community-module__oU5wjW__deleted",
  "discussionComposer": "Community-module__oU5wjW__discussionComposer",
  "discussionTitle": "Community-module__oU5wjW__discussionTitle",
  "empty": "Community-module__oU5wjW__empty",
  "engagement": "Community-module__oU5wjW__engagement",
  "engagementBar": "Community-module__oU5wjW__engagementBar",
  "error": "Community-module__oU5wjW__error",
  "heading": "Community-module__oU5wjW__heading",
  "iconAction": "Community-module__oU5wjW__iconAction",
  "liked": "Community-module__oU5wjW__liked",
  "linkButton": "Community-module__oU5wjW__linkButton",
  "loginHint": "Community-module__oU5wjW__loginHint",
  "muted": "Community-module__oU5wjW__muted",
  "pageContent": "Community-module__oU5wjW__pageContent",
  "pagination": "Community-module__oU5wjW__pagination",
  "pickerToggle": "Community-module__oU5wjW__pickerToggle",
  "primary": "Community-module__oU5wjW__primary",
  "reaction": "Community-module__oU5wjW__reaction",
  "reactionControl": "Community-module__oU5wjW__reactionControl",
  "reactionCount": "Community-module__oU5wjW__reactionCount",
  "reactionPicker": "Community-module__oU5wjW__reactionPicker",
  "reactions": "Community-module__oU5wjW__reactions",
  "readMore": "Community-module__oU5wjW__readMore",
  "reply": "Community-module__oU5wjW__reply",
  "replyContext": "Community-module__oU5wjW__replyContext",
  "secondary": "Community-module__oU5wjW__secondary",
  "sendComment": "Community-module__oU5wjW__sendComment",
  "srOnly": "Community-module__oU5wjW__srOnly",
  "stack": "Community-module__oU5wjW__stack",
});
